import { InfoCircleOutlined } from '@ant-design/icons';
import { getMarketPlaceSettings, setGsSelectedTab, setOthersSelectedTab, setSubscriptionSelectedTab, updateAttendanceReminderSettings, updateFeeSettings, updateMarketSettings, updateUserSettings } from 'actions/profileNew';
import { Col, Radio, Row, Switch, Tabs, TimePicker, Tooltip } from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';
import { Button } from 'components/Button';
import PageHeader from 'components/pageHeader';
import moment from 'moment';
import AttendanceRequirement from 'pages/attendanceNew/attendanceRequirement';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { easySwitch } from './subComponents';
import MarketPlaceTab from './marketPlaceTab';
import GoLiveModal from './goLiveModal';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getAttendanceDashBoardData } from 'actions/attendanceNew';
import FourOFourPage from 'pages/FourOFourPage';
import SaveConfirmation from './saveConfirmation';
import './styles.css';

const days = {
    M: "monday",
    T: "tuesday",
    W: "wednesday",
    Th: "thursday",
    F: "friday",
    S: "saturday",
    Su: "sunday"
}

const tabs = (attendanceDataContainer, allAttendanceRequirement, instituteProfile, updateSettings, saveRequirements, setSaveRequirements, user, selectedTab, setSaveButtonHidden, disabledClockOutHours, disabledClockOutMinutes) => {
    const allTabs = {}
    // Replaced by the Student Device Change Approval Requests card on the user management dashboard.
    // if (user.privilage.includes("Admin") || user.privilage.includes("SuperAdmin")) {
    //     Object.assign(allTabs, {
    //         "User management": {
    //             body: (
    //                 <div>
    //                     <div style={{ fontSize: 18, fontWeight: 600 }} className="m-t-10">
    //                         Student's registration request
    //                     </div>
    //                     <div style={{ color: "#636363" }}>
    //                         student’s registration request to be auto approved.
    //                     </div>
    //                     <div className='m-t-10'>
    //                         {/* <Radio checked={instituteProfile?.settings?.studentAutoApprove === true} onClick={() => updateSettings(true, "studentAutoApprove")}>Auto approval</Radio> */}
    //                         <Radio checked={true} onClick={() => updateSettings(true, "studentAutoApprove")}>Auto approval</Radio>
    //                     </div>
    //                     {/* <div className='m-t-20'>
    //                         <Radio checked={instituteProfile?.settings?.studentAutoApprove === false} onClick={() => updateSettings(false, "studentAutoApprove")}>Manual approval</Radio>
    //                     </div> */}
    //                 </div>
    //             )
    //         },
    //     })
    // }
    if (user.privilage.includes("FeeManager") || user.privilage.includes("SuperAdmin")) {
        Object.assign(allTabs, {
            "Fee management": {
                body: (
                    <div>
                        <div className='m-t-10'>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6
                                }}
                            >
                                <div style={{ fontSize: 18, fontWeight: 600 }} >
                                    Processing fee
                                </div>
                                <div>
                                    <Tooltip placement="right" title={
                                        <div>
                                            <div>Platform Fee - {instituteProfile?.transactionFeePercent ?? 4}%</div>
                                        </div>
                                    }>
                                        <InfoCircleOutlined style={{ color: "#1089FF" }} />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                        <div style={{ color: "#636363" }}>
                            {/* Selected party will bear the transaction charges while fee payment. */}
                            The selected party will pay the transaction charges during fee payment.
                        </div>
                        <div className='m-t-10'>
                            <Radio checked={instituteProfile?.settings?.transactionPaidBy === "student"} onClick={() => updateSettings("student", "transactionPaidBy")}>Processing fee payable by student</Radio>
                        </div>
                        <div className='m-t-10'>
                            <Radio checked={instituteProfile?.settings?.transactionPaidBy === "institute"} onClick={() => updateSettings("institute", "transactionPaidBy")}>Processing fee payable by institute</Radio>
                        </div>
                        <div style={{ width: "100%", borderBottom: "1px solid #E6E6E6", marginBottom: 10, marginTop: 20 }} />
                        <div style={{ fontSize: 18, fontWeight: 600 }} className="m-t-10">
                            Payment invoice
                        </div>
                        <div style={{ color: "#636363" }}>
                            {/* Generate and send payment invoice to payee automatically /manually after successfully transaction. */}
                            Generate and send the payment invoice to the payer automatically or manually after a successful transaction.
                        </div>
                        <div className='m-t-10'>
                            <Radio checked={instituteProfile?.settings?.invoiceType === "automatic"} onClick={() => updateSettings("automatic", "invoiceType")}>Automatic</Radio>
                        </div>
                        <div className='m-t-10'>
                            <Radio checked={instituteProfile?.settings?.invoiceType === "manual"} onClick={() => updateSettings("manual", "invoiceType")}>Manual</Radio>
                        </div>
                    </div>
                )
            }
        })
    }
    if (user.privilage.includes("LeaveManager") || user.privilage.includes("SuperAdmin")) {
        Object.assign(allTabs, {
            "Attendance": {
                body: (
                    <AttendanceRequirement isSubcomponent={true} saveRequirements={saveRequirements} setSaveRequirementsFalse={() => setSaveRequirements(false)} selectedTab={selectedTab} setSaveButtonHidden={setSaveButtonHidden} />

                )
            },
        })
    }


    {
        attendanceDataContainer?.attendanceSystem === 'aulas' && Object.assign(allTabs, {
            "Attendance reminder": {
                body: (
                    <div style={{ width: "100%" }}>
                        <div className='r-jsb' style={{ alignItems: 'center' }}>
                            <div>
                                <div style={{ fontSize: 18, fontWeight: 600 }} className="m-t-10">
                                    Reminder alert
                                </div>
                                <div style={{ color: "#636363" }}>
                                    You’ll be reminded to Clock in/Clout out at your preferred timings.
                                </div>
                            </div>
                            <div>
                                <Switch onChange={(e) => updateSettings(e, "reminderNeeded")} checked={instituteProfile.reminderNeeded} />
                            </div>
                        </div>
                        {instituteProfile.reminderNeeded &&
                            <>
                                <Row style={{ width: "100%", justifyContent: 'space-between' }} className="m-t-20">
                                    <Col style={{ width: "50%" }}  >
                                        <div style={{ color: "#636363" }} className="m-b-5">
                                            Clockin alert (9AM to 11AM)
                                        </div>
                                        <TimePicker style={{ width: "90%" }}
                                            onChange={time => updateSettings(time, 'clockInTime')}
                                            inputReadOnly minuteStep={15} format="HH:mm"
                                            value={instituteProfile.clockInTime ? moment(instituteProfile.clockInTime, "HH:mm:ss") : null}
                                            defaultOpenValue={moment('00:00', 'HH:mm')}
                                        />
                                    </Col>
                                    <Col style={{ width: "50%" }} >
                                        <div style={{ color: "#636363" }} className="m-b-5">
                                            Clockout alert (5PM to 7PM)
                                        </div>
                                        <TimePicker style={{ width: "90%" }}
                                            disabled={!instituteProfile.clockInTime}
                                            inputReadOnly
                                            onChange={time => updateSettings(time, 'clockOutTime')}
                                            minuteStep={15} format="HH:mm"
                                            value={instituteProfile.clockOutTime ? moment(instituteProfile.clockOutTime, "HH:mm:ss") : null}
                                            defaultOpenValue={moment('00:00', 'HH:mm')}
                                            disabledHours={disabledClockOutHours}
                                            disabledMinutes={disabledClockOutMinutes}
                                        />
                                    </Col>
                                </Row>
                                <div className="m-t-20">
                                    <div style={{ color: "#636363" }} className="m-b-5">
                                        Repeat
                                    </div>
                                    <div>
                                        {Object.keys(days).map((day, index) =>
                                            <button key={index}
                                                style={{
                                                    width: 45, height: 45, borderRadius: 25, cursor: 'pointer',
                                                    fontWeight: instituteProfile?.repeatDays?.includes(day) ? "bold" : 'regular',
                                                    color: instituteProfile?.repeatDays?.includes(day) ? "#594099" : '#AEAEAE',
                                                    background: instituteProfile?.repeatDays?.includes(day) ? "#F6F4FE" : 'white',
                                                    border: "1px solid #E6E6E6"
                                                }} className="m-r-10"
                                                onClick={() => updateSettings(day, 'repeatDays')}
                                            >
                                                {day}
                                            </button>)}
                                    </div>
                                </div>
                            </>}
                    </div>
                )
            }
        })
    }


    if (user.privilage.includes("SuperAdmin")) {
        Object.assign(allTabs, {
            "Marketplace": {
                body: (
                    <div>
                        <MarketPlaceTab />
                    </div>
                )
            },
        })
    }
    return allTabs

}
const TabsComponent = ({ attendanceDataContainer, allAttendanceRequirement, handleTabSelect, selectedTab, instituteProfile, updateSettings, saveRequirements, setSaveRequirements, user, setSaveButtonHidden, disabledClockOutHours, disabledClockOutMinutes }) => {

    return (
        <Tabs onChange={handleTabSelect} activeKey={selectedTab} destroyInactiveTabPane={true}>
            {Object.keys(tabs(attendanceDataContainer, allAttendanceRequirement, instituteProfile, updateSettings, saveRequirements, setSaveRequirements, user, selectedTab, setSaveButtonHidden, disabledClockOutHours, disabledClockOutMinutes)).map((tab, index) => (
                <TabPane tab={tab} key={tab}>
                    {tabs(attendanceDataContainer, allAttendanceRequirement, instituteProfile, updateSettings, saveRequirements, setSaveRequirements, user, selectedTab, setSaveButtonHidden, disabledClockOutHours, disabledClockOutMinutes)[tab].body}
                </TabPane>
            )
            )}
        </Tabs>
    )
}


const GeneralSettings = ({ setGsSelectedTab, gsSelectedTab,
    instituteDetails, updateFeeSettings, updateUserSettings,
    updateAttendanceReminderSettings, attendanceReminderSettings, user,
    setSubscriptionSelectedTab, setOthersSelectedTab, updateMarketSettings, getMarketPlaceSettings, marketPlaceData, getAttendanceDashBoardData, attendanceDataContainer, allAttendanceRequirement,
    attendanceVendorData, storeAttendanceSsystem
}) => {
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get('tab');
    const decodedTab = tabParam ? decodeURIComponent(tabParam) : null;
    const validTabs = [/* "Banners", "Enquiry form", */ "Outstanding Results", "Testimonials", "Footer"];
    const isInvalidTab = tabParam !== null && !validTabs.includes(decodedTab);
    const [saveConfirmationModal, setSaveConfirmationModal] = useState(false);

    useEffect(() => {
        if (decodedTab && validTabs.includes(decodedTab)) {
            setGsSelectedTab("Marketplace");
        }
    }, [location.search]);
    const prevReminderSettingsRef = useRef();
    const prevInstituteDetailsRef = useRef();
    const prevTabRef = useRef();

    useEffect(() => {
        const prevReminderSettings = prevReminderSettingsRef.current;
        const prevInstituteDetails = prevInstituteDetailsRef.current;
        const prevTab = prevTabRef.current;

        const reminderSettingsChanged = JSON.stringify(attendanceReminderSettings) !== JSON.stringify(prevReminderSettings);
        const instituteDetailsChanged = JSON.stringify(instituteDetails) !== JSON.stringify(prevInstituteDetails);
        const tabChanged = gsSelectedTab !== prevTab;

        if (reminderSettingsChanged || instituteDetailsChanged || tabChanged) {
            const repeatDays = attendanceReminderSettings?.settings?.repeat?.map(item => Object.keys(days).find(key => days[key] === item))
            setProfileDetails({
                ...instituteDetails,
                settings: { ...instituteDetails.settings },
                ...attendanceReminderSettings.settings,
                repeatDays, reminderNeeded: attendanceReminderSettings?.enabled
            });
            prevReminderSettingsRef.current = attendanceReminderSettings;
            prevInstituteDetailsRef.current = instituteDetails;
            prevTabRef.current = gsSelectedTab;
        }
    }, [instituteDetails, attendanceReminderSettings, gsSelectedTab]);

    const [instituteProfile, setProfileDetails] = useState({});
    const [saveButtonHidden, setSaveButtonHidden] = useState(true);
    const [saveRequirements, setSaveRequirements] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [goLiveLoader, toggleGoLiveLoader] = useState(false);
    const [goLiveModal, toggleGoLiveModal] = useState(false);

    const getClockInTimeString = () => {
        if (!instituteProfile.clockInTime) return null;
        if (moment.isMoment(instituteProfile.clockInTime)) {
            return instituteProfile.clockInTime.format("HH:mm:ss");
        }
        return instituteProfile.clockInTime;
    };

    const disabledClockOutHours = () => {
        const timeStr = getClockInTimeString();
        if (!timeStr) return [];
        const parts = timeStr.split(':');
        const selectedHour = parseInt(parts[0], 10);
        
        const hours = [];
        for (let i = 0; i < selectedHour; i++) {
            hours.push(i);
        }
        return hours;
    };

    const disabledClockOutMinutes = (selectedHourVal) => {
        const timeStr = getClockInTimeString();
        if (!timeStr) return [];
        const parts = timeStr.split(':');
        const selectedHour = parseInt(parts[0], 10);
        const selectedMinute = parseInt(parts[1], 10);

        const minutes = [];
        if (selectedHourVal === selectedHour) {
            for (let i = 0; i <= selectedMinute; i++) {
                minutes.push(i);
            }
        }
        return minutes;
    };


    useEffect(() => {
        getAttendanceDashBoardData();
    }, [allAttendanceRequirement])

    useEffect(() => {
        switch (gsSelectedTab) {
            case "User management":
                if (instituteProfile?.settings?.studentAutoApprove !== instituteDetails?.settings?.studentAutoApprove) {
                    setSaveButtonHidden(false)
                } else {
                    setSaveButtonHidden(true)
                }
                break;
            case "Fee management":
                if (instituteProfile?.settings?.transactionPaidBy !== instituteDetails?.settings?.transactionPaidBy ||
                    instituteProfile?.settings?.invoiceType !== instituteDetails?.settings?.invoiceType) {
                    setSaveButtonHidden(false)
                } else {
                    setSaveButtonHidden(true)
                }
                break;
            case "Attendance reminder":
                if (instituteProfile.reminderNeeded) {
                    if (!instituteProfile.clockInTime || !instituteProfile.clockOutTime ||
                        !instituteProfile.repeatDays || !instituteProfile.repeatDays.length
                    ) {
                        setSaveButtonHidden(true)
                    } else {
                        const isTimeSame = (instituteProfile.clockInTime === attendanceReminderSettings?.settings?.clockInTime) &&
                                           (instituteProfile.clockOutTime === attendanceReminderSettings?.settings?.clockOutTime);
                        const isToggleSame = (instituteProfile.reminderNeeded === attendanceReminderSettings?.enabled);
                        
                        const dbDays = attendanceReminderSettings?.settings?.repeatDays || [];
                        const curDays = instituteProfile.repeatDays || [];
                        const isDaysSame = dbDays.length === curDays.length && dbDays.every(d => curDays.includes(d));

                        if (isTimeSame && isToggleSame && isDaysSame) {
                            setSaveButtonHidden(true)
                        } else {
                            setSaveButtonHidden(false)
                        }
                    }
                } else if (instituteProfile.reminderNeeded !== attendanceReminderSettings?.enabled) {
                    setSaveButtonHidden(false)
                } else {
                    setSaveButtonHidden(true)
                }
                break;

            case "Marketplace":
                setSaveButtonHidden(true);
                break;
        }
    }, [instituteProfile, gsSelectedTab, attendanceVendorData, storeAttendanceSsystem])

    useEffect(() => {
        if (!saveRequirements) {
            setButtonLoader(false)
        }
    }, [saveRequirements])


    useEffect(() => {
        if (user.privilage.includes("SuperAdmin") || user.privilage.includes("Admin")) {
            getMarketPlaceSettings()
        }
    }, [marketPlaceData?.active])

    if (isInvalidTab) {
        return <FourOFourPage history={history} />;
    }

    const handleTabSelect = (key) => {
        setGsSelectedTab(key);
    }

    const updateSettings = (value, type) => {
        switch (type) {
            case "studentAutoApprove":
            case "invoiceType":
            case "transactionPaidBy":
                instituteProfile.settings[type] = value;
                break;
            case "repeatDays":
                if (!instituteProfile.repeatDays) {
                    instituteProfile.repeatDays = []
                }
                if (instituteProfile?.repeatDays?.includes(value)) {
                    instituteProfile?.repeatDays.splice(instituteProfile?.repeatDays.indexOf(value), 1)
                } else {
                    instituteProfile?.repeatDays.push(value)
                }
                break;
            case "clockInTime":
                instituteProfile.clockInTime = value;
                if (value && instituteProfile.clockOutTime) {
                    const inStr = moment.isMoment(value) ? value.format("HH:mm:ss") : value;
                    const outStr = moment.isMoment(instituteProfile.clockOutTime) ? instituteProfile.clockOutTime.format("HH:mm:ss") : instituteProfile.clockOutTime;
                    const inMoment = moment(inStr, "HH:mm:ss");
                    const outMoment = moment(outStr, "HH:mm:ss");
                    if (outMoment.isSameOrBefore(inMoment)) {
                        instituteProfile.clockOutTime = null;
                    }
                }
                break;
            case "reminderNeeded":
                instituteProfile.reminderNeeded = value;
                if (!value) {
                    instituteProfile.clockInTime = null;
                    instituteProfile.clockOutTime = null;
                    instituteProfile.repeatDays = [];
                }
                break;
            default:
                instituteProfile[type] = value;
                break;
        }
        setProfileDetails({ ...instituteProfile })
    }
    const handleSaveClick = () => {
        if (gsSelectedTab === "Fee management") {
            setSaveConfirmationModal(true);
            return;
        }
        setButtonLoader(true)
        switch (gsSelectedTab) {

            case "User management":
                updateUserSettings({ studentAutoApproved: instituteProfile?.settings?.studentAutoApprove }, () => setButtonLoader(false))
                break;
            case "Fee management":
                updateFeeSettings(
                    { transactionPaidBy: instituteProfile?.settings?.transactionPaidBy, invoiceType: instituteProfile.settings?.invoiceType },
                    () => setButtonLoader(false))
                break;
            case "Attendance":
                setSaveRequirements(true)

                // saveButtonRef.click();
                break;
            case "Attendance reminder":
                const params = {
                    enabled: instituteProfile.reminderNeeded,
                    settings: {
                        clockInTime: instituteProfile.reminderNeeded 
                            ? (instituteProfile.clockInTime === attendanceReminderSettings?.settings?.clockInTime ? instituteProfile.clockInTime : moment(instituteProfile.clockInTime).format("HH:mm:ss"))
                            : (attendanceReminderSettings?.settings?.clockInTime || null),
                        clockOutTime: instituteProfile.reminderNeeded 
                            ? (instituteProfile.clockOutTime === attendanceReminderSettings?.settings?.clockOutTime ? instituteProfile.clockOutTime : moment(instituteProfile.clockOutTime).format("HH:mm:ss"))
                            : (attendanceReminderSettings?.settings?.clockOutTime || null),
                        repeat: instituteProfile.reminderNeeded 
                            ? (instituteProfile.repeatDays?.map(item => days[item]))
                            : (attendanceReminderSettings?.settings?.repeat || [])
                    }
                }
                updateAttendanceReminderSettings(params, (err) => {
                    setButtonLoader(false);
                })
                break;
        }
    }
    const handleFeeManagementSave = (closeModal, stopLoader) => {
        updateFeeSettings(
            {
                transactionPaidBy: instituteProfile?.settings?.transactionPaidBy,
                invoiceType: instituteProfile?.settings?.invoiceType
            },
            () => {
                stopLoader();
                closeModal();
                setSaveConfirmationModal(false);
                setButtonLoader(false);
            }
        );
    };

    const handleBackPress = () => {
        if (location?.state?.fromMarketPlaceMenu) {
            history.push('/market-place');
        }
        // If coming from course modal, go back to previous page
        else if (location?.state?.key === "fromCourse") {
            history.push('/courses');
        } else {
            history.push('/account-settings');
        }
    }
    

    const handleGoliveClick = () => {
        toggleGoLiveLoader(true)
        updateMarketSettings({ settingData: { active: marketPlaceData?.active == false && true } }, () => toggleGoLiveLoader(false), () => { toggleGoLiveModal(false); getMarketPlaceSettings() });
    }

    const handleGoOffline = () => {
        toggleGoLiveLoader(true)
        updateMarketSettings({ settingData: { active: marketPlaceData?.active == true && false } }, () => toggleGoLiveLoader(false), () => { toggleGoLiveModal(false); getMarketPlaceSettings() });
    }

    const openGoLiveModal = () => {
        toggleGoLiveModal(true)
    }

    const actions = [
        gsSelectedTab === 'Marketplace'
            ? !marketPlaceData?.active ? (
                <Button onClick={openGoLiveModal} type='transparent' style={{ fontWeight: 700, color: '#594099' }}>
                    GO LIVE
                </Button>
            ) : (
                <Button onClick={openGoLiveModal} type='transparent' style={{ fontWeight: 700, color: '#FF414D' }}>
                    GO OFFLINE
                </Button>
            ) : null,
        (gsSelectedTab != 'User management' && gsSelectedTab != 'Marketplace') && <Button type="link" style={{ fontSize: 14 }} loading={buttonLoader} disabled={saveButtonHidden}
            // onClick={handleSaveClick}
            onClick={() => {
                if (gsSelectedTab === "Fee management") {
                    setSaveConfirmationModal(true);
                } else {
                    handleSaveClick();
                }
            }}>SAVE</Button>,
    ];

    return (
        <div className="general-settings-container" style={{ height: "100%" }} >
            <PageHeader
                title="General Settings"
                onBackPress={handleBackPress}
                actions={actions}
                easySwitch={easySwitch(history, user, setGsSelectedTab, setSubscriptionSelectedTab, setOthersSelectedTab).length > 1 ? easySwitch(history, user, setGsSelectedTab, setSubscriptionSelectedTab, setOthersSelectedTab) : undefined}
            />
            <div className='r-c-c'>
                <div style={{ width: "100%" }} className="m-t-50">
                    <TabsComponent
                        handleTabSelect={handleTabSelect}
                        selectedTab={gsSelectedTab}
                        saveRequirements={saveRequirements}
                        setSaveRequirements={setSaveRequirements}
                        instituteProfile={instituteProfile}
                        updateSettings={updateSettings}
                        user={user}
                        attendanceDataContainer={attendanceDataContainer}
                        allAttendanceRequirement={allAttendanceRequirement}
                        setSaveButtonHidden={setSaveButtonHidden}
                        disabledClockOutHours={disabledClockOutHours}
                        disabledClockOutMinutes={disabledClockOutMinutes}
                    />
                </div>
            </div>
            {goLiveModal && <GoLiveModal handleGoliveClick={handleGoliveClick} open={goLiveModal} onCancel={() => toggleGoLiveModal(false)} goLiveLoader={goLiveLoader} handleGoOffline={handleGoOffline} active={marketPlaceData?.active} toggleGoLiveModal={toggleGoLiveModal} />}
            {saveConfirmationModal && (
                <SaveConfirmation
                    saveConfirmationModal={saveConfirmationModal}
                    onCancel={() => setSaveConfirmationModal(false)}
                    handleOk={handleFeeManagementSave}
                    setSaveConfirmationModal={setSaveConfirmationModal}
                />
            )}
        </div>
    );
}


const mapStateToProps = (state) => {
    const { user } = state.session;
    const { attendanceDataContainer, allAttendanceRequirement, attendanceVendorData, storeAttendanceSsystem } = state.attendanceNew;
    const { gsSelectedTab, instituteDetails, attendanceReminderSettings, marketPlaceData } = state.profileNew;
    return {
        gsSelectedTab, instituteDetails, attendanceReminderSettings, user, marketPlaceData, attendanceDataContainer, allAttendanceRequirement,
        attendanceVendorData, storeAttendanceSsystem
    }
}

const mapDispatchToProps = (dispatch) => ({
    setGsSelectedTab: (tab) => dispatch(setGsSelectedTab(tab)),
    updateFeeSettings: (params, callback) => dispatch(updateFeeSettings(params, callback)),
    updateUserSettings: (params, callback) => dispatch(updateUserSettings(params, callback)),
    updateAttendanceReminderSettings: (params, callback) => dispatch(updateAttendanceReminderSettings(params, callback)),
    setSubscriptionSelectedTab: (tab) => dispatch(setSubscriptionSelectedTab(tab)),
    setOthersSelectedTab: (tab) => dispatch(setOthersSelectedTab(tab)),
    updateMarketSettings: (params, callback, successCallback) => dispatch(updateMarketSettings(params, callback, successCallback)),
    getMarketPlaceSettings: () => dispatch(getMarketPlaceSettings()),
    getAttendanceDashBoardData: (callBack) => dispatch(getAttendanceDashBoardData(callBack))

})

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSettings);
